// import { IUserEvents } from '.';

interface IUserEventsCollectedData {
    'user-activity.event/type': string;
    'user-activity.event/occurred-at': string;
    'user-activity.event/logged-at': string;
    'user-management.user/id': string;
    'user-activity.event/url': string;
    'telestrations.game-footage/id'?: string;
}
type IUserEvents =
    | 'user-activity.game-footage/open-game-footage-library'
    | 'user-activity.game-footage/open-upload-form'
    | 'user-activity.game-footage/start-upload'
    | 'user-activity.game-footage/upload-complete'
    | 'user-activity.game-footage/watch-footage'
    | 'user-activity.game-footage/watch-footage'
    | 'user-activity.game-footage/click-to-telestrate'
    | 'user-activity.game-footage/sort-footage'
    | 'user-activity.game-footage/exit-page'
    | 'user-activity.game-footage/delete-footage'
    | 'user-activity.game-footage/rename-footage'
    | 'user-activity.subscribe/open-subscribe-page'
    | 'user-activity.subscribe/click-through-to-stripe'
    | 'user-activity.telestration/opened-telestration'
    | 'user-activity.telestration/clicked-mask-tool'
    | 'user-activity.telestration/applied-mask-to-field'
    | 'user-activity.telestration/undo-mask-tool'
    | 'user-activity.telestration/save-mask-setting'
    | 'user-activity.telestration/halo-click'
    | 'user-activity.telestration/applied-halo-to-field'
    | 'user-activity.telestration/clicked-polygon-tool'
    | 'user-activity.telestration/started-drawing-polygon'
    | 'user-activity.telestration/finished-drawing-polygon'
    | 'user-activity.telestration/clicked-circle'
    | 'user-activity.telestration/applied-circle-to-field'
    | 'user-activity.telestration/clicked-link-cursor'
    | 'user-activity.telestration/added-linked-cursor-to-field'
    | 'user-activity.telestration/finished-linked-cursor'
    | 'user-activity.telestration/clicked-undo'
    | 'user-activity.telestration/started-recording'
    | 'user-activity.telestration/finished-recording'
    | 'user-activity.telestration/start-saved-recording'
    | 'user-activity.telestration/cancel-saved-recording'
    | 'user-activity.telestration/finish-saving-recording'
    | 'user-activity.telestration/clicked-straight-arrow'
    | 'user-activity.telestration/clicked-straight-arrow'
    | 'user-activity.telestration/clicked-segment-arrow'
    | 'user-activity.telestration/clicked-clear'
    | 'user-activity.telestration/click-sidebar-help-button';

const url = process.env.REACT_APP_ALEPH_URI;

async function sendEvent(collectedData: IUserEventsCollectedData) {
    try {
        await fetch(url + '/api-v1/ua/events/log', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(collectedData),
        });
    } catch (error) {
        console.error(error);
    }
}

function collectUserActionData(
    userEvent: IUserEvents,
    location: string,
    videoId?: string
): void {
    const time = new Date();
    const userId: string = localStorage.getItem('userId') || '';
    const collectedData: IUserEventsCollectedData = {
        'user-activity.event/type': userEvent,
        'user-activity.event/occurred-at': time.toISOString(),
        'user-activity.event/logged-at': time.toISOString(),
        'user-management.user/id': userId,
        'user-activity.event/url': location,
    };
    if (userEvent.includes('telestration') || videoId) {
        if (videoId) {
            collectedData['telestrations.game-footage/id'] = videoId;
        } else {
            console.error('videoId missed');
        }
    }
    if (userId !== '') {
        sendEvent(collectedData);
    }
}

export const sendUserEvent = collectUserActionData;
